export const PERSON_TYPE_BENEFICIARY = 'beneficiary';
export const PERSON_TYPE_PARTICIPANT = 'participant';
export const PERSON_TYPE_PRESCRIBER = 'prescriber';
export const PERSON_TYPE_SIEL_BLEU = 'sielbleuuser';
